/**
 * Kpop Spotlight — frontend entry. Each part checks for its own markup first,
 * so pages without a spotlight pay nothing.
 */

import { initStillFallbacks } from './player.js';
import { initStages } from './stage.js';
import { initQueues } from './queue.js';
import { initCardPlayer } from './card-player.js';
import { initRails } from './rail.js';

export function initSpotlight() {
	if (!document.querySelector('.spot-stage, .spot-tile, .spot-pc')) return;
	initStillFallbacks();
	initStages();
	initQueues();
	initCardPlayer();
	initRails();
}
